<template>
  <div>
   
        <staffpay-history
        fromModule="onlystaff"
        :checkPaymentApproval="false"
        :checkGeneratSlipApproval="false"
        :checkDeletePermission="false"

        ></staffpay-history>
    <!-- invoice modal -->
    <div class="full-cstm-sidebar mt-107" :class="{ open: invoiceSidebar }">
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="invoiceSidebarData"
      >
        <div>
          <strong class="inline-flex whitespace-nowrap"
            >Invoice # {{ invoiceSidebarData.invoice_id }}</strong
          >
        </div>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="handleinvoiceSidebar"
        />
      </div>
      <vs-divider class="mb-0" />

    <!--   <invoice-sidebar
        v-if="invoiceSidebarData && schoolAddress && platformCustomerInfo"
        :invoiceSidebarData="invoiceSidebarData"
        :schoolAddress="schoolAddress"
        :platformCustomerInfo="platformCustomerInfo"
        @download="generateReport"
      ></invoice-sidebar> -->
    </div>
    <div class="bg-overlay"></div>

    <!-- pdf print -->
    <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Finance"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasDownloaded="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <invoice-preview
          v-if="invoiceSidebarData && schoolAddress && platformCustomerInfo"
          :invoiceSidebarData="invoiceSidebarData"
          :schoolAddress="schoolAddress"
          :platformCustomerInfo="platformCustomerInfo"
        ></invoice-preview>
      </section>
    </vue-html2pdf> -->

    <!-- pdf print -->
    <div class="bg-overlay"></div>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'
import InvoiceSidebar from './components/InvoiceSidebar.vue'
import ClientTable from './components/ClientTable'
import StaffTable from './components/StaffTable'
import VueHtml2pdf from 'vue-html2pdf'
import InvoicePreview from './components/InvoicePreview'
import FinanceSummery from '../analytics/summeryLIst'
import StaffpayHistory from './components/StaffpayHistory'

export default {
  name: 'Finance',
  components: {
    DateRangePicker,
    vSelect,
    InvoiceSidebar,
    ClientTable,
    StaffTable,
    VueHtml2pdf,
    InvoicePreview,
    FinanceSummery,
    StaffpayHistory
  },
  watch: {
    invoiceSidebar () {
      if (!this.invoiceSidebar) {
        this.invoiceSidebarData = null
      }
    }
  },
  data () {
    return {
      maximizeCard: true,
      schoolAddress: null,
      platformCustomerInfo: null,
      invoiceSidebarData: null,
      invoiceSidebar: false
    }
  },
  methods: {
    generateReport () {
      console.log('hi')
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
      }, 1000)
    },
    onProgress (event) {
      console.log(event)
      this.percentage = event
      this.showPercentage = true

      if (event == 100) {
        this.showPercentage = false
      }
      //   if(event===100)
    },
    hasGenerated (event) {
      console.log(event)
    },
    /*  openInvoiceSidebar () {
      this.invoiceSidebar = true
      document.body.classList.add('overflow-hidden')
    }, */
    handleinvoiceSidebar () {
      this.invoiceSidebar = false
      document.body.classList.remove('overflow-hidden')
    },
    listenOpenSidebar (invoiceData, schoolAddress, platformCustomerInfo) {
      console.log(platformCustomerInfo)
      console.log('hi')
      console.log(invoiceData)
      this.invoiceSidebarData = invoiceData
      this.schoolAddress = schoolAddress
      this.platformCustomerInfo = platformCustomerInfo
      // this.platform_customer=
      this.invoiceSidebar = true
      document.body.classList.add('overflow-hidden')
    }
  }
}
</script>
<style>
.finance-card {
  position: relative;
}
.filter-holder {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* width: calc(100% - 220px); */
}
.filter-holder .filter-holder-col {
  width: 22%;
}
.filter-holder .filter-holder-col:last-child {
  width: 12%;
}
/* .feather-icon {
  width: 16px;
} */
.finance-table .vs-table--thead tr {
  background: #e3e3e3;
}
.finance-card .con-ul-tabs,
.finance-table tr {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}
.finance-table .status-badge {
  display: block;
  text-align: center;
}
.finance-table .status-badge.overdue {
  background: #ffdede;
  color: #ff6b6c;
}
.finance-table .status-badge.pending {
  background: #e6eaee;
  color: #7e8fa3;
}
.finance-table .status-badge.paid {
  background: #d2ffe8;
  color: #73e8ad;
}
.finance-table .payment-holder span {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.filter-holder .vue-daterange-picker {
  height: 100%;
}
.filter-holder .reportrange-text {
  height: 100%;
  padding: 7px !important;
  border-radius: 5px;
}
.filter-holder .calendars {
  display: flex;
}
.invoice-table {
  width: 100%;
  border-collapse: collapse;
}
.invoice-table th {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.invoice-table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6px 10px;
}

@media (max-width: 1024px) {
  .finance-table {
    margin-top: 50px;
  }
  .finance-card .filter-holder {
    left: 0;
    width: 100%;
  }
}
@media (max-width: 991px) {
  .finance-table {
    margin-top: 85px;
  }
  .filter-holder .filter-holder-col {
    width: 50%;
  }
  .filter-holder .filter-holder-col:last-child {
    width: 15%;
  }
}
@media (max-width: 600px) {
  .finance-table {
    margin-top: 190px;
  }
  .filter-holder .filter-holder-col {
    width: 100%;
  }
  .filter-holder .filter-holder-col:last-child {
    width: 30%;
  }
}
@media (max-width: 480px) {
  .finance-table {
    margin-top: 205px;
  }
}

.progress {
  margin: 20px auto;
  padding: 0;
  width: 90%;
  height: 30px;
  overflow: hidden;
  background: #e5e5e5;
  border-radius: 6px;
}

.bar {
  position: relative;
  float: left;
  min-width: 1%;
  height: 100%;
  background: cornflowerblue;
}

.percent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-family: tahoma, arial, helvetica;
  font-size: 12px;
  color: white;
}
</style>